







































// Importing components
import BaseCard from '@/ui/BaseCard.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import TheFormProducts1 from '@/components/products/TheFormProducts1.vue';
import TheFormProducts2 from '@/components/products/TheFormProducts2.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing functions
import {validateProduct} from '@/ts/products/validate-product';
import {postProduct} from '@/ts/products/post-product';
import {getCategories} from '@/ts/categories/get-categories';
// Importing variables
import {InvalidImage} from '@/ts/variables';

export default {
    name: 'PageProductsCreate',
    components: {
        BaseCard,
        BaseAlertList,
        BaseLoadingAnimation,
        LayoutApp,
        TheFormProducts1,
        TheFormProducts2,
    },
    props: {},
    data() {
        return {
            data: Object(),
            errors: Array(),
            items: Array(),
            first_page: Boolean(true),
        };
    },
    methods: {
        next() {
            this.first_page = false;
        },
        back() {
            this.first_page = true;
        },
        onSubmit() {
            this.errors = [];

            validateProduct(this.errors, this.data);

            if (this.errors.length === 0) {
                postProduct(this.data, this.$route.params.id, this.$route.params.category_id).catch((error) => {
                    if (error.response.data.errors.image[0] === 'The image has invalid image dimensions.') {
                        this.data.tags = JSON.parse(this.data.tags);
                        this.data.ingredients = JSON.parse(this.data.ingredients);
                        this.data.addons = JSON.parse(this.data.addons);
                        this.data.variations = JSON.parse(this.data.variations);
                        this.errors.push(InvalidImage);
                    }
                }).then(() => {
                    this.$router.push({ name: 'products-create', params: {
                        id: this.$route.params.id,
                        category_id: this.$route.params.category_id,
                        category_name: this.$store.getters.response[0].attributes.menu_category,
                    }});
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Категории',
            to: { name: 'categories', params: { id: this.$route.params.id } },
        }, {
            text: 'Продукти',
            to: {
                name: 'products',
                params: {
                    id: this.$route.params.id,
                    category_id: this.$route.params.category_id,
                },
            },
        }, {
            text: 'Създаване',
        }];
        // Initializing the product object
        this.data = {
            name: '', description: '', is_active: '1',
            cook_time: '', code: '', kcal: '', tags: [],
            addons: [], ingredients: [], image: {},
            menu_category_id: '', variations: { old: [], created: [], deleted: [] },
        };
        if (this.$route.params.category_id === '') {
            getCategories(this.$route.params.id);
        }
    },
};
